<div id="contentToConvert" class="wrapper">
  <div [ngClass]="{ 'full-height': !router.url.includes('login') }">
    <router-outlet></router-outlet>
  </div>
</div>